export default "__VITE_ASSET__CQeFgCkc__"